import { StockStatus } from '~/shared/utils/getStockStatus';

import getBOPSStockStatus from './getBOPSStockStatus';

export const getWarehouseInventory = (productDetailContext, storeLocation) => {
  const { selectionStateByProductIndex } = productDetailContext;
  const isStorePresent = Boolean(storeLocation);
  const BOPSItem = {
    isAvailable: false,
    quantity: 0,
    stockStatus: StockStatus.SOLD_OUT,
  };

  if (storeLocation && !storeLocation.bopsAllowed) {
    BOPSItem.stockStatus = StockStatus.BOPS_UNAVAILABLE;
    return BOPSItem;
  }

  if (isStorePresent) {
    const warehouseInventory =
      selectionStateByProductIndex[0]?.selectedSKU?.warehouseInventory;

    if (warehouseInventory && warehouseInventory.length) {
      warehouseInventory.map((item) => {
        if (item.id === storeLocation.warehouseId) {
          if (item.quantity >= storeLocation.bopsMinInventory) {
            BOPSItem.isAvailable = true;
          }
          BOPSItem.quantity = item.quantity;
          BOPSItem.stockStatus = getBOPSStockStatus(storeLocation, item);
        }
      });
      return BOPSItem;
    }
  } else {
    return BOPSItem;
  }
};
